module.exports = __webpack_public_path__ + "img/cfreitas.aaa3595e.jpg";